import React from 'react';
import PropTypes from 'prop-types';
import { IconWithTooltip } from './IconWithTooltip';

export const AddIcon = ({ handleClick }) => (
  <IconWithTooltip
    handleClick={handleClick}
    ariaLabel="add"
    tooltip="Add"
    icon="plus-circle"
  />
);


AddIcon.propTypes = {
// eslint-disable-next-line react/require-default-props
  handleClick: PropTypes.func,
};
